<script>
  import { Link } from 'carbon-components-svelte';

  import StatusTooltip from '../StatusTooltip.svelte';

  export let dataServiceAssociations = [];
  export let ownerType, serviceName;
</script>

<StatusTooltip valid={dataServiceAssociations.some((association) => association.serviceName === serviceName)}>
  <span slot="errorText">
    This SSH key is not associated with this service.
    {#if ownerType === 'user'}
      To associate it, navigate to one of the user's groups.
    {/if}
  </span>
  <div class="service-association-tooltip" slot="validText">
    <span>This SSH key is associated with this service through the following group(s):</span>
    <ul>
      {#each dataServiceAssociations.filter((association) => association.serviceName === serviceName) as { group }}
        <li>
          <Link href={`/group/${group.id}#ssh-keys`} target="_blank">
            {group.name}
          </Link>
        </li>
      {/each}
    </ul>
  </div>
</StatusTooltip>

<style>
  .service-association-tooltip :global(.bx--link) {
    margin-top: 0.25rem;
  }
</style>
